var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { staticClass: "el-form-item" },
            [
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-right": "10px", float: "right" },
                  on: {
                    change: function ($event) {
                      return _vm.themeChange("backgroundColorSelect")
                    },
                  },
                  model: {
                    value: _vm.componentStyleForm.backgroundColorSelect,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.componentStyleForm,
                        "backgroundColorSelect",
                        $$v
                      )
                    },
                    expression: "componentStyleForm.backgroundColorSelect",
                  },
                },
                [
                  _c("span", { staticStyle: { "font-size": "12px" } }, [
                    _vm._v(_vm._s(_vm.$t("chart.chart_background"))),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            [
              _c("el-color-picker", {
                staticClass: "color-picker-style",
                attrs: {
                  disabled: !_vm.componentStyleForm.backgroundColorSelect,
                  size: "mini",
                  predefine: _vm.predefineColors,
                },
                on: {
                  change: function ($event) {
                    return _vm.themeChange("color")
                  },
                },
                model: {
                  value: _vm.componentStyleForm.color,
                  callback: function ($$v) {
                    _vm.$set(_vm.componentStyleForm, "color", $$v)
                  },
                  expression: "componentStyleForm.color",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "componentStyleForm",
          attrs: {
            model: _vm.componentStyleForm,
            "label-width": "70px",
            size: "mini",
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "form-item",
              attrs: { label: _vm.$t("panel.opacity") },
            },
            [
              _c("el-slider", {
                attrs: {
                  disabled: !_vm.componentStyleForm.backgroundColorSelect,
                  "show-input": "",
                  "show-input-controls": false,
                  "input-size": "mini",
                },
                on: {
                  change: function ($event) {
                    return _vm.themeChange("alpha")
                  },
                },
                model: {
                  value: _vm.componentStyleForm.alpha,
                  callback: function ($$v) {
                    _vm.$set(_vm.componentStyleForm, "alpha", $$v)
                  },
                  expression: "componentStyleForm.alpha",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "form-item",
              attrs: { label: _vm.$t("panel.board_radio") },
            },
            [
              _c("el-slider", {
                attrs: {
                  "show-input": "",
                  "show-input-controls": false,
                  "input-size": "mini",
                },
                on: {
                  change: function ($event) {
                    return _vm.themeChange("borderRadius")
                  },
                },
                model: {
                  value: _vm.componentStyleForm.borderRadius,
                  callback: function ($$v) {
                    _vm.$set(_vm.componentStyleForm, "borderRadius", $$v)
                  },
                  expression: "componentStyleForm.borderRadius",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }